var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailRecurrente({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.42578,
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.42578,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#ECECF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4375 33.0169C31.9731 33.4523 31.3599 33.7171 30.6875 33.7171C29.2377 33.7171 28.0625 32.4859 28.0625 30.9671C28.0625 29.4483 29.2377 28.2171 30.6875 28.2171C31.8304 28.2171 32.8028 28.9824 33.1631 30.0505M33.75 27.7588V30.5088H31.125M24.5625 32.3421H19.925C18.9449 32.3421 18.4549 32.3421 18.0805 32.1423C17.7512 31.9666 17.4835 31.6861 17.3157 31.3411C17.125 30.949 17.125 30.4355 17.125 29.4088V22.4421C17.125 21.4154 17.125 20.902 17.3157 20.5098C17.4835 20.1648 17.7512 19.8844 18.0805 19.7086C18.4549 19.5088 18.9449 19.5088 19.925 19.5088H30.075C31.0551 19.5088 31.5452 19.5088 31.9195 19.7086C32.2488 19.8844 32.5165 20.1648 32.6842 20.5098C32.875 20.902 32.875 21.4154 32.875 22.4421V24.0921M32.5309 22.4992L28.1062 25.5895C26.9835 26.3735 26.4222 26.7656 25.8155 26.9179C25.2793 27.0525 24.7204 27.0525 24.1842 26.9179C23.5775 26.7656 23.0162 26.3735 21.8935 25.5895L17.254 22.3492",
    stroke: "#4F5660",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailRecurrente);
export default __webpack_public_path__ + "static/media/emailRecurrente.f560116b3248a930756595766747f262.svg";
export { ForwardRef as ReactComponent };